/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersPostRequest model module.
 * @module model/CustomersPostRequest
 * @version 1.0.0
 */
class CustomersPostRequest {
    /**
     * Constructs a new <code>CustomersPostRequest</code>.
     * @alias module:model/CustomersPostRequest
     * @param emailAddress {String} 
     * @param firstName {String} 
     * @param lastName {String} 
     */
    constructor(emailAddress, firstName, lastName) { 
        
        CustomersPostRequest.initialize(this, emailAddress, firstName, lastName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, emailAddress, firstName, lastName) { 
        obj['emailAddress'] = emailAddress;
        obj['firstName'] = firstName;
        obj['lastName'] = lastName;
    }

    /**
     * Constructs a <code>CustomersPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersPostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersPostRequest} The populated <code>CustomersPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersPostRequest();

            if (data.hasOwnProperty('emailAddress')) {
                obj['emailAddress'] = ApiClient.convertToType(data['emailAddress'], 'String');
            }
            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('dateOfBirth')) {
                obj['dateOfBirth'] = ApiClient.convertToType(data['dateOfBirth'], 'String');
            }
            if (data.hasOwnProperty('activationProductId')) {
                obj['activationProductId'] = ApiClient.convertToType(data['activationProductId'], 'String');
            }
            if (data.hasOwnProperty('affiliateReferalCode')) {
                obj['affiliateReferalCode'] = ApiClient.convertToType(data['affiliateReferalCode'], 'String');
            }
            if (data.hasOwnProperty('psim')) {
                obj['psim'] = ApiClient.convertToType(data['psim'], 'Number');
            }
            if (data.hasOwnProperty('deliveryAddress')) {
                obj['deliveryAddress'] = ApiClient.convertToType(data['deliveryAddress'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersPostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersPostRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['emailAddress'] && !(typeof data['emailAddress'] === 'string' || data['emailAddress'] instanceof String)) {
            throw new Error("Expected the field `emailAddress` to be a primitive type in the JSON string but got " + data['emailAddress']);
        }
        // ensure the json data is a string
        if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
            throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
        }
        // ensure the json data is a string
        if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
            throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
        }
        // ensure the json data is a string
        if (data['dateOfBirth'] && !(typeof data['dateOfBirth'] === 'string' || data['dateOfBirth'] instanceof String)) {
            throw new Error("Expected the field `dateOfBirth` to be a primitive type in the JSON string but got " + data['dateOfBirth']);
        }
        // ensure the json data is a string
        if (data['activationProductId'] && !(typeof data['activationProductId'] === 'string' || data['activationProductId'] instanceof String)) {
            throw new Error("Expected the field `activationProductId` to be a primitive type in the JSON string but got " + data['activationProductId']);
        }
        // ensure the json data is a string
        if (data['affiliateReferalCode'] && !(typeof data['affiliateReferalCode'] === 'string' || data['affiliateReferalCode'] instanceof String)) {
            throw new Error("Expected the field `affiliateReferalCode` to be a primitive type in the JSON string but got " + data['affiliateReferalCode']);
        }
        // ensure the json data is a string
        if (data['deliveryAddress'] && !(typeof data['deliveryAddress'] === 'string' || data['deliveryAddress'] instanceof String)) {
            throw new Error("Expected the field `deliveryAddress` to be a primitive type in the JSON string but got " + data['deliveryAddress']);
        }

        return true;
    }


}

CustomersPostRequest.RequiredProperties = ["emailAddress", "firstName", "lastName"];

/**
 * @member {String} emailAddress
 */
CustomersPostRequest.prototype['emailAddress'] = undefined;

/**
 * @member {String} firstName
 */
CustomersPostRequest.prototype['firstName'] = undefined;

/**
 * @member {String} lastName
 */
CustomersPostRequest.prototype['lastName'] = undefined;

/**
 * Optional. Format YYYY-MM-DD.
 * @member {String} dateOfBirth
 */
CustomersPostRequest.prototype['dateOfBirth'] = undefined;

/**
 * @member {String} activationProductId
 */
CustomersPostRequest.prototype['activationProductId'] = undefined;

/**
 * @member {String} affiliateReferalCode
 */
CustomersPostRequest.prototype['affiliateReferalCode'] = undefined;

/**
 * 1 = physical SIM (adds dispatch item), 0 = eSIM
 * @member {module:model/CustomersPostRequest.PsimEnum} psim
 */
CustomersPostRequest.prototype['psim'] = undefined;

/**
 * @member {String} deliveryAddress
 */
CustomersPostRequest.prototype['deliveryAddress'] = undefined;





/**
 * Allowed values for the <code>psim</code> property.
 * @enum {Number}
 * @readonly
 */
CustomersPostRequest['PsimEnum'] = {

    /**
     * value: 0
     * @const
     */
    "0": 0,

    /**
     * value: 1
     * @const
     */
    "1": 1
};



export default CustomersPostRequest;

